import React from "react"
import cx from "classnames"

const commonClasses = ["flex"]
const mobileClasses = ["xs:flex-col-reverse flex-col-reverse"]
const desktopClasses = ["lg:flex-row"]

export const Hero = React.forwardRef(({ children, className }, ref) => {
  return (
    <div
      ref={ref}
      className={cx(
        ...commonClasses,
        ...mobileClasses,
        ...desktopClasses,
        className
      )}
    >
      {children}
    </div>
  )
})
